import referralProgramNew from '@/navigation/vertical/referralProgramNew'
import campaign from './campaign'
import dashboard from './dashboard'
import account from './account'
import prePreview from './prePreview'
import payment from './payment'
import billing from './billing'
import productLinks from './productLinks'
// import referralOld from './referraOld'
import referralProgram from './referralProgram'
import partner from './partner'
// import platform from './platform'
// import pixel from './pixel'
// import pody from './pody'
import videoGeneration from './videoGeneration'

export default [
  ...dashboard,
  ...account,
  // ...pody,
  ...prePreview,
  ...payment,
  // ...referralOld,
  ...productLinks,
  ...billing,
  // ...pixel,
  ...referralProgram,
  ...partner,
  ...referralProgramNew,
  // ...platform,
  ...campaign,
  ...videoGeneration,
]
